export enum InsuranceHistoryError {
    noInsuranceHistory = 'noInsuranceHistory',
    uzoviNotLinkedToInsurer = 'uzoviNotLinkedToInsurer',
    uzoviNotValid = 'uzoviNotValid',
}
